import React from 'react';
import { connect } from 'react-redux';
import TooltipElement from '../components/tooltipElement';
import TooltipButtonGroup from '../components/tooltipButtonGroup';
import DeviceFeaturesTable from '../components/deviceFeaturesTable';
import OverlayLoader from '../components/overlayLoader';
import * as deviceFeaturesActions from '../store/deviceFeaturesSlice';
import { deviceFeaturesSelectors } from '../store/deviceFeaturesSlice';
import * as ObjectDataActions from '../store/objectDataSlice';
import { objectDataNames, objectDataSelectors } from '../store/objectDataSlice';
import './common.css';
import setTitleToFilters from '../common/filtersTitles';

class DeviceFeaturesContainer extends React.Component {
  componentDidMount() {
    setTitleToFilters();
    this.props.fetchAllFeatureTypes();
    this.props.fetchAllDeviceFeatures();
  }

  render() {
    return (
      <OverlayLoader active={this.isLoading()} text={this.getLoaderMessage()}>
        <div>
          <h1>Device features</h1>
          {this.renderButtons()}
          {this.renderContent()}
        </div>
      </OverlayLoader>
    );
  }

  renderButtons = () => (
    <TooltipButtonGroup>
      <TooltipElement
        type="button"
        text="Refresh"
        icon="refresh"
        onClick={this.props.fetchAllDeviceFeatures}
      />
    </TooltipButtonGroup>
  );

  renderContent = () => {
    if (this.props.deviceFeaturesFetchingError)
      return this.renderError(this.props.deviceFeaturesFetchingError.toString());

    return (
      <React.Fragment>
        {this.props.featureTypes.error
          ? this.renderError(this.props.featureTypes.error.toString())
          : null}
        <DeviceFeaturesTable
          deviceFeatures={this.props.deviceFeatures}
          featureTypes={this.props.featureTypes.data}
        />
      </React.Fragment>
    );
  };

  renderError = (message) => <p className="text-danger">Error: {message}</p>;

  isLoading = () => 
    this.props.isDeviceFeaturesFetching || this.props.featureTypes.isFetching;

  getLoaderMessage = () => {
    if (this.props.isDeviceFeaturesFetching) {
      return 'Device features loading...';
    }
    if (this.props.featureTypes.isFetching) {
      return 'Feature types loading...';
    }
  };
};

const mapStateToProps = (state) => ({
  isDeviceFeaturesFetching: deviceFeaturesSelectors.isFetching(state),
  deviceFeatures: deviceFeaturesSelectors.selectAll(state),
  deviceFeaturesFetchingError: deviceFeaturesSelectors.fetchingError(state),

  featureTypes: objectDataSelectors.featureTypesState(state),
});

const actionCreators = {
  fetchAllDeviceFeatures: deviceFeaturesActions.fetchAllDeviceFeatures,
  fetchAllFeatureTypes: () =>
    ObjectDataActions.fetchObjectData({
      objectName: objectDataNames.featureTypes,
    }),
};


export default connect(mapStateToProps, actionCreators)(DeviceFeaturesContainer);


// WEBPACK FOOTER //
// ./src/containers/deviceFeaturesContainer.js